import { useTranslation } from 'react-i18next';
import { ComboboxOption } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/20/solid';

import { cn } from 'support/helpers/cn/cn';

import { dropdownClasses } from '../styles';
import { DropdownOptionType, DropdownSize } from '../types';

type ComboboxDropdownOptionsProps<TValue> = {
  options: Array<DropdownOptionType<TValue>>;
  size: DropdownSize;
};

export const ComboboxDropdownOptions = <TValue,>({ options, size }: ComboboxDropdownOptionsProps<TValue>) => {
  const { t } = useTranslation();

  return (
    <>
      {options.map((option) => (
        <ComboboxOption
          as="li"
          key={String(option.value)}
          className={({ focus, disabled }) =>
            cn(
              focus ? 'bg-procuros-green-500' : '',
              'relative ml-0 cursor-default select-none',
              disabled ? 'text-gray-500' : 'text-black',
              dropdownClasses.listItem.size[size],
              // Option rows keep py-2 at every size; the size's own vertical padding is for the search input.
              'py-2',
            )
          }
          value={option.value}
          disabled={option.disabled}
          data-testid={option.testId}
        >
          {({ selected, focus }) => (
            <span className="flex justify-between gap-2">
              <span className={cn(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                {t(option.label)}
              </span>

              {selected ? (
                <span className={cn(focus ? 'text-white' : 'text-procuros-green-600', 'flex items-center')}>
                  <CheckIcon className="size-4" aria-hidden="true" />
                </span>
              ) : null}
            </span>
          )}
        </ComboboxOption>
      ))}
    </>
  );
};
